import { gql } from "@apollo/client";
import { useMutation, useQuery } from "@apollo/client/react";
import { useState } from "react";

import ReadCategory from "./ReadCategory.graphql";
import UpsertCategory from "./UpsertCategory.graphql";
import * as UI from "../../../../../modules/ui-kit";
import categoryDefinition from "../categoryDefinition";

export default function Publishing(props) {
    const { id, public: isPublic } = props;

    const readCategory = useQuery(
        gql(ReadCategory),
        {
            variables: {
                id,
            },
        },
    );

    const [upsertCategory] = useMutation(
        gql(UpsertCategory),
        {
            // The side list styles draft categories differently.
            awaitRefetchQueries: true,
            refetchQueries: [
                gql(ReadCategory),
                "ListCategories",
            ],
            variables: {
                id,
            },
        },
    );

    const [busy, setBusy] = useState(false);

    if (readCategory.loading) return "loading";
    if (readCategory.error) return "error";

    async function setPublic(value: boolean) {
        setBusy(true);
        try {
            await upsertCategory(
                {
                    variables: {
                        definition: categoryDefinition(
                            readCategory.data,
                            {
                                public: value,
                            },
                        ),
                    },
                }
            );
        } finally {
            setBusy(false);
        }
    }

    return (
        <UI.Button
            $appearance={ isPublic ? "danger" : "primary" }
            $size="small"
            disabled={ busy }
            onClick={ () => setPublic(!isPublic) }
        >
            {
                busy
                    ? (isPublic ? "Unpublishing…" : "Publishing…")
                    : (isPublic ? "Unpublish" : "Publish")
            }
        </UI.Button>
    );
}
